module.exports = __webpack_public_path__ + "img/pengajuan.4ebdc12d.png";